module.exports = __webpack_public_path__ + "static/media/c-3po.6eb9002b.jpg";